import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiParams, ApiRequest, ApiService, SortDir } from './api.service';
import { Job } from '@shared';

export interface ApplicationHistoryParams extends ApiParams {
  'sort.by': string;
  'sort.direction': SortDir;
}

@Injectable({ providedIn: 'root' })
export class ApplicationHistoryService extends ApiService<Job> {
  constructor(http: HttpClient) {
    super(http);
  }

  getApplicationHistory(
    request: Partial<ApiRequest<ApplicationHistoryParams>> = {},
  ): Observable<any> {
    const url = 'job-description/application-history/candidate/';
    return super.get({ url, ...request });
  }
}
